import { createLogger } from 'shared/services/logger';

const logger = createLogger('UScope:extensions:Snapshot:ImageReader');

export class ImageReader {
  async capture (viewport, rectangle, zoom) {
    return new Promise(async (resolve, reject) => {
      const rawUri = viewport.urlBuilder.region(rectangle.x, rectangle.y, rectangle.w, rectangle.h, zoom);
      const blob = await requestTileAsBlob(rawUri);
      const blobUri = URL.createObjectURL(blob);
      const img = new Image();
      img.crossOrigin = 'anonymous';

      img.onload = () => {
        this.image = img;
        resolve();
      };
      img.onerror = (e) => {
        reject(e);
      };
      img.src = blobUri;
    });
  }

  render (context) {
    context.drawImage(this.image, 0, 0);
  }

  cleanup () {
    if (this.image) {
      URL.revokeObjectURL(this.image.src);
      delete this.image;
    } else {
      logger.warn('Called ImageReader::cleanup() more than once.');
    }
  }
}

export async function requestTileAsBlob (url) {
  const request = new XMLHttpRequest();
  return new Promise(function (resolve, reject) {
    request.addEventListener('load', (e) => {
      if (request.status > 299) {
        reject(request);
      } else {
        const blob = new Blob([request.response], {
          type: request.getResponseHeader('content-type')
        });
        resolve(blob);
      }
    });
    request.open('GET', url);
    request.responseType = 'arraybuffer';
    request.setRequestHeader('Accept', 'image/webp,image/*,*/*;q=0.8');
    request.send();
  });
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/capturing/readers/ImageReader.js